export default __webpack_public_path__ + "static/media/Emma.b8c3a51a.jpg";